module.exports = __webpack_public_path__ + "static/img/1.5f5442e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1.png
// module id = W23E
// module chunks = 1